import { CloudinaryImage_File } from 't2-graphql-types';
import { useAnalytics } from '../AnalyticsProvider/AnalyticsProvider';
import { TCloudinaryImageShape } from '../CloudinaryResponsiveImage/types';
import { AuthorDetailContainer } from '../ArticleHeader/AuthorDetailContainer';

type TPromptAuthorLinkProps = {
  author: {
    name: string;
    username: string;
    profileImage: CloudinaryImage_File;
  };
};

export const PromptAuthorLink = ({ author: { name, username, profileImage } }: TPromptAuthorLinkProps) => {
  const { sendEvent } = useAnalytics();

  const onClick = () => {
    sendEvent('prompt_author_click');
  };

  return (
    <AuthorDetailContainer
      name={name}
      username={username}
      profileImageSize="medium"
      profileImage={profileImage as TCloudinaryImageShape}
      onClick={onClick}
    />
  );
};
